var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"my-5"},[_c('v-col',[_c('HeadMetadata',{attrs:{"title":_setup.pageTitle}}),(_setup.showLoadingText)?_c('span',[_vm._v("Please wait while Almanac+ is loading...")]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }